export default "__VITE_ASSET__C8VVc624__"